import React from 'react';
import CrudPage from '../../../components/CrudPage';
import { AUDIT_COLUMNS } from '../../../config/columns';
import { bankUmumService } from '../../../services/resources';

export default function BankUmumPage({ onToast }) {
  return (
    <CrudPage
      title="Bank Umum"
      formCode="BANK_UMUM"
      service={bankUmumService}
      onToast={onToast}
      searchKeys={['bank_name']}
      columns={[{ key: 'bank_name', label: 'Bank Name' }, ...AUDIT_COLUMNS]}
      fields={[
        { key: 'bank_name', label: 'Bank Name', type: 'text', required: true, immutableOnEdit: true, uppercase: true },
      ]}
    />
  );
}
